import className from 'classnames';
import { useLocation, Link } from 'react-router-dom';

import { Icon } from './Icon';

interface SideNavTextItemProps {
  icon: string;
  url: string;
  title: string;
}

export const SideNavTextItem = ({ title, icon, url }: SideNavTextItemProps): JSX.Element => {
  const { pathname } = useLocation();
  const isItemActive = url === pathname;

  return (
    <Link
      to={url}
      className={className(
        'flex mb-4 flex-shrink-0 hover:bg-primary-1.0 py-2 px-1 rounded no-underline',
        isItemActive ? 'bg-primary-1.0 font-bold' : ''
      )}
      data-testid={`nav-${title}`}
      id={title}
    >
      <div className="flex items-center my-auto ml-4">
        <Icon name={icon} className="text-xl flex-shrink-0 text-white-1.0" />
        <p className="text-white-1.0 ml-2 text-md font-semibold">{title}</p>
      </div>
    </Link>
  );
};
